import React from 'react'

import { useModalContext } from 'containers/ModalManager'
import { ExportColorTokensModal } from './ExportColorTokensModal'
import {
  ExportButton,
  ButtonText,
  ExplanationText,
  ExportContainer,
  ExportContainerSeparator,
} from './ExportColorTokens.styles'
import { useGetComponentsCountQuery } from '@sketch/gql-types'
import { useGetIdentifiers } from '../../operations/useGetIdentifiers'
import { useVersioning } from 'modules/versioning'
import useUserSignedIn from 'modules/user/useUserSignedIn'
import { trackEvent } from 'modules/analytics'

import { ReactComponent as TokenIcon } from '@sketch/icons/token-16-svg'

const SIDEBAR_BREAKPOINT = 210

export const ExportColorTokens = () => {
  const { shareIdentifier, versionShortId } = useGetIdentifiers()
  const { showModal } = useModalContext()
  const isUserSignedIn = useUserSignedIn()
  const { share } = useVersioning()

  const { loading, data, error } = useGetComponentsCountQuery({
    variables: {
      shareIdentifier,
      versionShortId,
    },
    skip: !shareIdentifier || !versionShortId || !isUserSignedIn,
  })

  const colorVarsCount = data?.share?.version?.document?.componentCount
    .colorVar!

  if (loading || error || !colorVarsCount || !isUserSignedIn) {
    return null
  }

  const sidebarWidth = document.getElementsByClassName('cwvSidebar')[0]
    ?.scrollWidth
  const isNarrowSidebar = sidebarWidth < SIDEBAR_BREAKPOINT
  const buttonCopy = !isNarrowSidebar ? (
    <>Export Color Tokens&hellip;</>
  ) : (
    <>Color Tokens</>
  )

  const handleExportClick = () => {
    trackEvent('CWV - export color tokens button clicked', {})

    showModal(ExportColorTokensModal, {
      shareIdentifier,
      userAccessLevel: share.userAccessLevel,
      versionShortId,
    })
  }

  return (
    <ExportContainer>
      <ExportContainerSeparator />
      <ExplanationText>
        Export your Color Variables as JSON and CSS, or create a public link
      </ExplanationText>
      <ExportButton
        $narrowSidebar={isNarrowSidebar}
        size="32"
        onClick={handleExportClick}
      >
        <TokenIcon height={16} />
        <ButtonText>{buttonCopy}</ButtonText>
      </ExportButton>
    </ExportContainer>
  )
}
